module.exports = __webpack_public_path__ + "media/images/sp/banner/hokepon_via_ad-f4d63ac0455a5921d9c66d7431609c88.png";